<div class="dashboard-center-layout component-container">
  <div class="fg-1">
    <div class="inverse-bg-transparent">
      <div class="header-container">
        <div class="row">
          <div class="cell">
            <h2 class="no-mg">{{"WRITE_MESSAGE.RULE_BASED_MESSAGES" | translate}}</h2>
          </div>
          <div class="row-inline grid-sm">
            <div class="cell">
              <span class="p-input-icon-left p-input-filled">
                <i class="pi pi-search"></i>
                <input #search type="text" pInputText
                  [placeholder]="('MESSAGES.FORM_LABELS.SEARCH_RULE'|translate)"
                  (input)="ruledMessageRowRef.rowReference.filterGlobal(search.value , 'contains')" />
                </span>
              </div>
              <div class="divider-v darken"></div>
              <div class="cell">
                <!--[disabled]="!hasPermission"-->
                <button pButton pRipple type="button" (click)="openRuleModalForm($event)"
                  class="btn btn-primary">
                  <i aria-hidden="true" class="icon icon-plus"></i>
                  {{'COMMON.BUTTONS.CREATE_NEW_RULE'|translate}}
                </button>
              </div>
            </div>
          </div>
        </div>
        @if (loaded) {
          <div class="pt-16 mg-offset">
            <app-yabi-table #ruledMessageRowRef [tableConfig]="tableConfig" (onAction)="toMessageAction($event)"
              scrollHeight="calc(100vh - 280px)" [globalFilterFields]="['title']"
            [rowBackgroundColor]="'auto'"></app-yabi-table>
          </div>
        }
        @if (!loaded && hasPermission) {
          <div>
            <div class="no-ruled-messages">
              <img src="assets/no-certicates-created.svg" width="350" alt="" class="mb-10">
              <h1 class="no-mg">{{"MESSAGES.NO_RULE_MESSAGES"|translate}}</h1>
              <h3 class="color-gray">{{"MESSAGES.PLEASE_CREATE_NEW_RULE_BASE_MESSAGE"|translate}}</h3>
            </div>
          </div>
        }
        <!--           <div *ngIf="!hasPermission">
        <div class="no-ruled-messages">
          <img src="assets/no-permisson-to-feature.svg" width="350" alt="" class="mb-10"
            [class.rotate]="dir=='rtl'">
            <h1 class="no-mg">{{"COMMON.IMAGES_TITLES.THE_FEATURE_REQUIRE_SUBSCRIPTION"|translate}}</h1>
            <h3 class="color-gray">{{"MESSAGES.SUBSCRIBE_TO_CREATE_MESSAGE_RIGHT_AWAY"|translate}}</h3>
          </div>
        </div> -->
      </div>
    </div>

    <app-ruled-message-modal #writeRuleMessage (onClose)="onStartFetchMessages()" (onSave)="onStartFetchMessages()"
      [targets]="targets" [triggers]="triggers" [initiators]="initiators" [clientId]="clientId"
      [authorizedCategoryId]="authorizedCategoryId" [employeesCategoryId]="employeesCategoryId"
      [activeModuleName]="activeModuleName">
    </app-ruled-message-modal>

    <p-toast position="bottom-right"></p-toast>